module.exports = __webpack_public_path__ + "static/media/support v2.9dbff737.png";